import { memo } from 'react';

import { Alert, Button } from '@bringg/react-components';

import styles from './error-state.module.scss';

type Props = {
	alertMessage: string;
	buttonText: string;
	handleRetryFetch: () => void;
};

export const ErrorState = memo(({ alertMessage, buttonText, handleRetryFetch }: Props) => {
	return (
		<div className={styles.errorState}>
			<Alert className={styles.errorStateAlert} showIcon type="error" message={alertMessage} />
			<Button type="primary" onClick={handleRetryFetch}>
				{buttonText}
			</Button>
		</div>
	);
});

ErrorState.displayName = 'ErrorState';
